import { render, staticRenderFns } from "./TakipVeTahsilatDataTable.vue?vue&type=template&id=57e37f39&scoped=true"
import script from "./TakipVeTahsilatDataTable.vue?vue&type=script&lang=ts"
export * from "./TakipVeTahsilatDataTable.vue?vue&type=script&lang=ts"
import style0 from "./TakipVeTahsilatDataTable.vue?vue&type=style&index=0&id=57e37f39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e37f39",
  null
  
)

export default component.exports